/** ຄ່າເລີ່ມຕົ້ນເມື່ອຍັງບໍ່ມີແຖວໃນ DB ຫຼື API ລົ້ມເຫຼວ */
export const DEFAULT_ISSUER_COMPANY_NAME = "ບໍລິສັດ ຕົວຢ່າງ";

export const DEFAULT_ISSUER_COMPANY_ADDRESS = "ທີ່ຢູ່ບໍລິສັດ, ນະຄອນຫຼວງວຽງຈັນ";

export const DEFAULT_ISSUER_COMPANY_CONTACT =
  "contact@example.la, 020 xxxx xxxx";

export const ISSUER_SETTINGS_ROW_ID = "default" as const;
